"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  NAME: {
    columnName: 'name',
    align: 'left'
  },
  VIEWS: {
    columnName: 'views'
  },
  CONVERSION: {
    columnName: 'conversion'
  },
  CONTACTS: {
    columnName: 'contacts'
  },
  CREATED_AT: {
    columnName: 'createdAt'
  }
};
exports.default = _default;
module.exports = exports.default;